(function () {
	document.querySelectorAll('.boa-contact-form__form').forEach(function (form) {
		const container = form.closest('[data-msg-required]');
		if (!container) {
			return;
		}

		const requiredMessage = container.dataset.msgRequired;
		const invalidMessage = container.dataset.msgInvalid;

		form.querySelectorAll('[required]').forEach(function (field) {
			field.addEventListener('invalid', function () {
				if (field.validity.valueMissing) {
					field.setCustomValidity(requiredMessage);
				} else if (field.validity.typeMismatch || field.validity.patternMismatch) {
					field.setCustomValidity(invalidMessage);
				} else {
					field.setCustomValidity('');
				}
			});
			field.addEventListener('input', function () {
				field.setCustomValidity('');
			});
		});

		form.addEventListener('submit', function () {
			const submitButton = form.querySelector('button[type="submit"]');
			if (submitButton && form.checkValidity()) {
				submitButton.disabled = true;
				submitButton.textContent = container.dataset.msgSubmitting;
			}
		});
	});
})();
